<div
  class="ui visible message"
  *ngIf="!filtersArray.length"
>
  You have not added any filters yet. Click on the plus (+) button below to start adding filters.
</div>
<div
  class="wrapper"
  *ngFor="let arr of filtersArray; let i = index; let isLastBlock = last; trackBy: trackByFiltersArray"
>
  <div
    class="ui grid container container__filter"
    [ngClass]="{ 'container__filter--last': isLastFilter && isLastBlock }"
    *ngFor="
      let filter of arr.expressions;
      let j = index;
      let isLastFilter = last;
      trackBy: trackByFiltersExpressions.bind(this, i)
    "
  >
    <div
      class="four wide column dropdown"
      [class.disabled]="readonly"
    >
      <dropdown
        [ngModel]="findFilterSource(filter)"
        (modelChange)="changeFilterSource($event, i, j, true)"
        [options]="filterSourceList"
        [editableOptions]="editableFilterSources"
        [settings]="dropdownSingleSettings"
        class="fluid search selection"
        [class.error]="filterSourceWarnings[i][j]"
        (click)="onFilterSourceDropdown(filter)"
      ></dropdown>
      <div
        *ngIf="filterSourceWarnings[i][j]"
        class="warning"
      >
        <span class="warning__text">Incompatible dimension</span>
        <span
          class="ui tooltip"
          [attr.data-tooltip]="
            'This dimension is not compatible with one or more selected dimensions or global filters. Change or remove the dimension/filter to resolve this.'
          "
          data-position="right center"
          data-inverted=""
        >
          <i class="question circle icon"></i>
        </span>
      </div>
    </div>

    <div
      [class.disabled]="!filter.isSearchable || readonly || !options.showMultipleOptions"
      class="four wide column dropdown"
    >
      <dropdown
        [ngModel]="findQueryFilterOption(filter.type)"
        placeholder="Select Filter"
        (modelChange)="changeFilterType($event, i, j, !isDateDimension(filter))"
        [options]="filterOptions"
        [editableOptions]="editableFilterOptions[i][j]"
        [settings]="dropdownSingleSettings"
        class="fluid search selection"
      ></dropdown>
    </div>
    <div
      [class.disabled]="!filter.isSearchable || readonly"
      class="five wide column dropdown"
    >
      <p-multiSelect
        *ngIf="queryFilterSelection[i][j] === 'any' || queryFilterSelection[i][j] === 'not_any'"
        [styleClass]="emptyFilterValueWarnings[i][j] ? 'tw-min-w-full tw-bg-yellow-100' : 'tw-min-w-full'"
        [panelStyle]="{ 'max-width': '25rem' }"
        optionLabel="value"
        placeholder="Select Values"
        display="chip"
        appendTo="body"
        [filter]="true"
        [loadingIcon]="'fa-solid fa-circle-notch fa-spin'"
        [options]="matches[filter.key]"
        [loading]="matches[filter.key]?.length ? false : loading[i][j]"
        [(ngModel)]="filter.values"
        (onChange)="onValueChange($event.value, i, j)"
        (onClick)="multiSelectDropdownClick(filter, i, j)"
        (onPanelShow)="focusSearch()"
      >
        <ng-template
          pTemplate="filter"
          let-value
          let-options="options"
        >
          <div class="tw-flex tw-items-center tw-w-full tw-mb-2">
            <p-iconField
              class="tw-w-full"
              iconPosition="right"
            >
              <p-inputIcon>
                <i class="tw-leading-4 tw-align-middle tw-mb-3 fa-solid fa-magnifying-glass"></i>
              </p-inputIcon>
              <input
                #filterInput
                pInputText
                type="text"
                class="tw-w-full"
                (input)="onFilterInputChange(filterInput.value, filter, i, j)"
              />
            </p-iconField>
          </div>
        </ng-template>

        <ng-template
          let-selectedItems
          pTemplate="selectedItems"
        >
          <div class="selected-items">
            <ng-container *ngIf="selectedItems?.length; else placeholder">
              <p-chip
                *ngFor="let item of selectedItems"
                styleClass="tw-my-1 tw-text-sm tw-flex tw-gap-1 tw-justify-between"
                [removable]="true"
                (onRemove)="removeSelectedFilterValue($event, item, i, j)"
              >
                <div class="tw-w-36 tw-break-words">
                  <span class="tw-font-semibold">{{ item.value }}</span>
                  <span
                    *ngIf="item.slice"
                    class="tw-ml-1"
                  >
                    ({{ item.slice }})
                  </span>
                </div>
              </p-chip>
            </ng-container>
            <ng-template #placeholder>
              <span>Select Values</span>
            </ng-template>
          </div>
        </ng-template>
        <ng-template
          let-dimension
          pTemplate="item"
        >
          <div>
            <span class="tw-font-semibold">{{ dimension.value }}</span>
            <span
              *ngIf="dimension.slice"
              class="tw-ml-1"
            >
              ({{ dimension.slice }})
            </span>
          </div>
        </ng-template>

        <ng-template pTemplate="empty">
          <div class="tw-p-2 tw-text-gray-500">
            {{ loading[i][j] ? 'Searching...' : 'No results found' }}
          </div>
        </ng-template>
      </p-multiSelect>

      <div
        class="ui input fluid"
        [class.warn]="emptyFilterValueWarnings[i][j]"
        *ngIf="
          queryFilterSelection[i][j] !== 'any' &&
          queryFilterSelection[i][j] !== 'not_any' &&
          queryFilterSelection[i][j] !== 'na' &&
          queryFilterSelection[i][j] !== 'not_na' &&
          queryFilterSelection[i][j] !== 'anything' &&
          !isDateDimension(filter)
        "
      >
        <input
          type="text"
          placeholder="Value..."
          [disabled]="!filter.type"
          [(ngModel)]="filter.values"
          (ngModelChange)="onValueChange($event, i, j)"
          [class.error]="emptyFilterValueWarnings[i][j] && !filter.values"
        />
      </div>
      <div
        class="tw-flex tw-gap-2 tw-items-center tw-flex-col"
        [class.warn]="emptyFilterValueWarnings[i][j]"
        *ngIf="isDateDimension(filter)"
      >
        <p-selectButton
          *ngIf="
            !editingThirdPartyDataset &&
            queryFilterSelection[i][j] !== 'is_in' &&
            queryFilterSelection[i][j] !== 'not_is_in'
          "
          styleClass="tw-w-full"
          [options]="dateTypeOptions"
          [(ngModel)]="selectedDateTypes[i][j]"
          (onChange)="onValueChange(null, i, j)"
          [allowEmpty]="false"
          optionValue="value"
        >
          <ng-template
            let-item
            pTemplate="item"
          >
            <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-[0.9em]">
              <i [class]="item.icon"></i>
              <span
                [class.tw-text-blue-500]="item.value === selectedDateTypes[i][j]"
                [class.tw-text-gray-500]="item.value !== selectedDateTypes[i][j]"
              >
                {{ item.label }}
              </span>
            </div>
          </ng-template>
        </p-selectButton>
        <div
          *ngIf="queryFilterSelection[i][j] !== 'is_in' && queryFilterSelection[i][j] !== 'not_is_in'"
          class="tw-w-full"
        >
          <ng-container *ngIf="selectedDateTypes[i][j] === 'static' || editingThirdPartyDataset; else dynamicDate">
            <p-calendar
              styleClass="tw-w-full"
              [ngModel]="getDateValue(filter, i, j)"
              [showIcon]="true"
              [iconDisplay]="'input'"
              [disabled]="!filter.type"
              (onSelect)="onValueChange($event, i, j)"
              (onClear)="onValueChange(null, i, j)"
              (onClearClick)="onValueChange(null, i, j)"
              [class.error]="emptyFilterValueWarnings[i][j] && !filter.values"
              dateFormat="yy-mm-dd"
              [showButtonBar]="true"
              [showOnFocus]="true"
              [placeholder]="'Select date...'"
            ></p-calendar>
          </ng-container>
          <ng-template #dynamicDate>
            <div class="tw-flex tw-w-full tw-gap-2 tw-items-center tw-justify-center">
              <p-inputNumber
                [min]="0"
                [max]="999"
                [showButtons]="true"
                inputStyleClass="tw-w-[5em]"
                [class.warn]="emptyFilterValueWarnings[i][j]"
                [ngModel]="getDateValue(filter, i, j)?.num"
                (onInput)="onDynamicDateChange({ num: $event.value }, i, j)"
                [class.error]="emptyFilterValueWarnings[i][j] && !filter.values"
              ></p-inputNumber>
              <span>days</span>
              <p-dropdown
                styleClass="tw-w-full"
                panelStyleClass="tw-w-36"
                [options]="dynamicDateDirectionOptions"
                [ngModel]="getDateValue(filter, i, j)?.direction || 'ago'"
                (onChange)="onDynamicDateChange({ direction: $event.value }, i, j)"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
              ></p-dropdown>
            </div>
          </ng-template>
        </div>
        <div
          *ngIf="queryFilterSelection[i][j] === 'is_in' || queryFilterSelection[i][j] === 'not_is_in'"
          class="tw-w-full"
        >
          <div class="tw-flex tw-w-full tw-gap-2 tw-items-center tw-justify-center">
            <p-dropdown
              styleClass="tw-w-full"
              panelStyleClass="tw-w-36"
              [options]="dateRangeRelationOptions"
              [ngModel]="getDateValue(filter, i, j)?.relation || 'last'"
              (onChange)="onDynamicDateRangeChange({ relation: $event.value }, i, j)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
            ></p-dropdown>
            <p-dropdown
              styleClass="tw-w-full"
              panelStyleClass="tw-w-36"
              [options]="dateRangeUnitOptions"
              [ngModel]="getDateValue(filter, i, j)?.unit || 'week'"
              (onChange)="onDynamicDateRangeChange({ unit: $event.value }, i, j)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
            ></p-dropdown>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          emptyFilterValueWarnings[i][j] &&
          queryFilterSelection[i][j] !== 'na' &&
          queryFilterSelection[i][j] !== 'not_na' &&
          queryFilterSelection[i][j] !== 'anything'
        "
        class="warning"
      >
        <span class="warning__text">Value missing</span>
        <span
          class="ui tooltip"
          [attr.data-tooltip]="
            'The query will ignore an empty filter line. Please select a value from the dropdown menu or add text input to include it in the query.'
          "
          data-position="right center"
          data-inverted=""
        >
          <i class="question circle icon"></i>
        </span>
      </div>
    </div>
    <div
      class="three wide column buttons-group"
      *ngIf="!readonly"
    >
      <div class="buttons-group">
        <ng-container *ngIf="options.showOrFilters">
          <button
            class="ui icon button button--or notHide"
            (click)="addFilter(i, j)"
            [ngClass]="{ disabled: !isLastFilter }"
          >
            <i
              class="plus icon"
              *ngIf="isLastFilter"
            ></i>
            <span>OR</span>
          </button>
        </ng-container>
        <button
          class="circular ui icon button button--remove notHide"
          (click)="removeFilter(i, j)"
        >
          <i class="x icon"></i>
        </button>
      </div>
    </div>
  </div>
  <div
    class="ui grid container button--and disabled notHide"
    *ngIf="!isLastBlock"
  >
    <button class="ui icon button disabled">
      <span>AND</span>
    </button>
  </div>
</div>

<button
  class="circular ui icon button button--add notHide"
  (click)="addBlock()"
  *ngIf="!readonly"
>
  <i class="plus icon"></i>
</button>
